import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React from "react";
import groupImgFirst from "../../Assets/Images/GroupImgFirst.png";
import groupImgSecond from "../../Assets/Images/GroupImgSecond.png";
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    display: "flex",
    fontFamily: "Lato",
  },
  coverTitle: {
    marginBottom: "10px",
    fontSize: "18px",
    fontWeight: 700,
    lineHeight: "10px",
    color: "#426B88",
    fontFamily: "Lato",
  },
  contentContainer: {
    textAlign: "center",
    maxWidth: "800px",
    marginTop: "10px",
  },
  paragraph: {
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
    marginBottom: "10px",
    marginTop: "5px",
  },
  imageContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "40px", 
    marginTop: "20px",
  },
  imageWrapper: {
    textAlign: "center",
    justifyContent: "center"
  },
  coverImage: {
    width: "205px",
    height: "205px",
    marginBottom: "10px",
  },
  optionTitle: {
    fontWeight: "700",
    fontFamily: "Lato",
    fontSize: "18px",
    color: "#426B88",
    lineHeight: "21px",
    marginLeft: "22%",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
  },
  flowText: {
    fontWeight: "700",
    fontFamily: "Lato",
    fontSize: "14px",
    color: "#426B88",
    lineHeight: "26px",
    justifyContent: "center",
    alignContent: "center",
    marginTop: "10px"
  },
  noteText: {
    fontSize: "10px",
    color: "#245775",
    textAlign: "center",
    width: "565px",
    height: "36px",
    padding: "10% 20% 0 20%",
},
  noteContainer: {
    marginTop: 5, 
   padding: "10% 12% 0 12%",

  },
  
  noteBold: {
    fontSize: 12,
    fontWeight: 700, 
    color: "#245775",
  },
  
  noteText: {
    fontSize: 12,
    fontWeight: 400, 
    color: "#426B88", 
    lineHeight: 2,    
    letterSpacing: 0,  
  },
});

const GroupQuadrantFlowSecondPage = () => {
  return (
    <View style={styles.coverSection}>
      <Text style={styles.coverTitle}>GROUP QUADRANT FLOW</Text>
      <View style={styles.contentContainer}>
        <Text style={styles.paragraph}>
          Quadrant Flow is a concept in personal and professional development
          that focuses on the movement of energy from one primary quadrant—
          Heart, Soul, Mind, and Strength—to the others, providing a holistic
          view of personality. Unlike traditional assessments that box
          individuals into fixed types, Quadrant Flow emphasizes the fluidity of
          personality, showing that everyone has aspects of all four quadrants.
        </Text>
        <Text style={styles.paragraph}>
          The journey through these quadrants offers insights into personal
          growth paths, highlighting that our so-called weaknesses or blind
          spots, represented by the last quadrant we flow into, are actually
          opportunities for learning and development. This approach encourages a
          more balanced and comprehensive self-awareness by recognizing
          potential growth areas rather than deficiencies.
        </Text>

        {/* Two image layout */}
        <View style={styles.imageContainer}>
          {/* Left Image */}
          <View style={styles.imageWrapper}>
            <Text style={styles.optionTitle}>OPTION 1</Text>
            <Image src={groupImgFirst} style={styles.coverImage} />
            <Text style={styles.flowText}>YOU FLOW FROM HEART TO SOUL</Text>
          </View>

          {/* Right Image */}
          <View style={styles.imageWrapper}>
            <Text style={styles.optionTitle}>OPTION 2</Text>
            <Image src={groupImgSecond} style={styles.coverImage} />
            <Text style={styles.flowText}>YOU FLOW FROM SOUL TO HEART</Text>
          </View>
        </View>

        {/* Note Section */}
        <View style={styles.noteContainer}>
          <Text>
            <Text style={styles.noteBold}>Note:</Text>
            <Text style={styles.noteText}>
              {" "}
              Your group exhibits an equal flow between the Heart and Soul
              quadrants, moving seamlessly in both directions.
            </Text>
          </Text>
        </View>
      </View>
    </View>
  );
};

export default GroupQuadrantFlowSecondPage;
